<template>
    <div>
        <div class="stage"></div>
    </div>
</template>

<style scoped>
    /*.stage {
        width: 100%;
        height: 100%;
    } */
</style>
<script>
    import * as PIXI from "pixi.js";

    export default {
        name: "TableView",
        props: ['tournamentId', 'webSocket'],
        data() {
            return {
                app: null,
                mainContainer: null,
                scaleFactor: 1,
                cardWidth: 233,
                cardHeight: 328,
                cardFaceValues: ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'],
                cardSuits: ['c', 's', 'd', 'h'],
                cardSprites: {
                    c: {},
                    s: {},
                    d: {},
                    h: {}
                },
                framesSprites: {
                    activePlayer: null,
                    inactivePlayer: null,
                    mainFrame: null,
                    noProfileImage: null,
                },
                players: {
                    1: {
                        frame: {
                            x: 100,
                            y: 660,
                            sprite: null
                        },
                        cards: []
                    },
                    2: {
                        frame: {
                            x: 150,
                            y: 320,
                            sprite: null
                        },
                        cards: []
                    },
                    3: {
                        frame: {
                            x: 0,
                            y: 0,
                            sprite: null
                        },
                        cards: []
                    },
                    4: {
                        frame: {
                            x: 0,
                            y: 0,
                            sprite: null
                        },
                        cards: []
                    },
                    5: {
                        frame: {
                            x: 0,
                            y: 0,
                            sprite: null
                        },
                        cards: []
                    },
                    6: {
                        frame: {
                            x: 0,
                            y: 0,
                            sprite: null
                        },
                        cards: []
                    },
                    7: {
                        frame: {
                            x: 0,
                            y: 0,
                            sprite: null
                        },
                        cards: []
                    },
                    8: {
                        frame: {
                            x: 0,
                            y: 0,
                            sprite: null
                        },
                        cards: []
                    },
                },
                tableBackground: null
            };
        },
        mounted() {
            window.PIXI = PIXI;
            this.mainContainer = new PIXI.Container();
            let mql = window.matchMedia("(orientation: portrait)");


            // If there are matches, we're in portrait
            if (mql.matches) {
                this.orientation = 'portrait';
            } else {
                this.orientation = 'landscape';
            }

            // Add a media query change listener
            if (mql.addEventListener) {
                mql.addEventListener("change", this.orientationChange);
            } else {
                mql.addListener(this.orientationChange);
            }

            if (PIXI.Loader.shared.resources["../vpoker-resources/pokertable.jpg"]) {
                this.setup();
            } else {
                PIXI.Loader.shared
                    .add("../vpoker-resources/pokertable.jpg")
                    .add("../vpoker-resources/frames.json")
                    .add("../vpoker-resources/cards.json")
                    .load(this.setup);
            }
        },
        methods: {
            orientationChange(m) {
                if (m.matches) {
                    this.orientation = 'portrait';
                    /*this.app.renderer.view.style.transform = "rotate(-90deg)";
                    this.app.renderer.view.style.transformOrigin = "left top";*/
                } else {
                    this.orientation = 'landscape';
                    /*this.app.renderer.view.style.transform = "";
                    this.app.renderer.view.style.transformOrigin = "";*/
                }
                this.resize();
            },
            setup() {
                let cardsSheet = PIXI.Loader.shared.resources["../vpoker-resources/cards.json"].spritesheet;
                let framesSheet = PIXI.Loader.shared.resources["../vpoker-resources/frames.json"].spritesheet;
                this.app = new PIXI.Application({
                    resizeTo: window,
                    backgroundColor: 0x1099bb,
                    transparent: false,
                    antialias: true,
                });

                this.cardFaceValues.forEach((faceValue) => {
                    this.cardSuits.forEach((suit) => {
                        var graphics = new PIXI.Graphics();
                        graphics.beginTextureFill(cardsSheet.textures[`${faceValue}${suit}.png`]);
                        graphics.lineStyle(4, 0x0, 0);
                        graphics.drawRoundedRect(
                            0,
                            0,
                            233,
                            328,
                            10
                        );
                        graphics.endFill();
                        this.cardSprites[suit][faceValue] = new PIXI.Sprite(this.app.renderer.generateTexture(graphics));
                    });
                });

                Object.keys(this.framesSprites).forEach((key) => {
                    this.framesSprites[key] = new PIXI.Sprite(framesSheet.textures[`${key}.png`]);
                });

                this.$el.appendChild(this.app.view);
                this.app.renderer.view.style.display = "block";
                this.mainContainer.sortableChildren = true;
                this.app.stage.addChild(this.mainContainer);
                this.tableBackground = new PIXI.Sprite(PIXI.Loader.shared.resources['../vpoker-resources/pokertable.jpg'].texture);

                this.tableBackground.width = parent.clientWidth;
                this.tableBackground.height = parent.clientHeight;
                this.tableBackground.zIndex = 0;

                // Set up player frames
                for (let i = 1; i <= 8; i++) {
                    this.players[i].frame.container = new PIXI.Container();
                    this.players[i].frame.sprite = new PIXI.Sprite(this.framesSprites.inactivePlayer.texture);
                    this.players[i].frame.sprite.zIndex = 1;
                    this.players[i].frame.container.sortableChildren = true;
                    this.players[i].frame.container.addChild(this.players[i].frame.sprite);
                    this.players[i].frame.container.zIndex = 2;
                    this.players[i].frame.container.originalX = this.players[i].frame.x;
                    this.players[i].frame.container.originalY = this.players[i].frame.y;
                    this.players[i].frame.container.position.set(this.players[i].frame.x, this.players[i].frame.y);

                    this.players[i].cards.push(new PIXI.Sprite(this.cardSprites.c.K.texture));
                    this.players[i].cards.push(new PIXI.Sprite(this.cardSprites.s.K.texture));
                    this.players[i].cards.forEach((cardSprite, index) => {
                        cardSprite.width = 76.89 * this.scaleFactorX;
                        cardSprite.height = 108.24000000000001 * this.scaleFactorY;
                        if (index === 0) {
                            cardSprite.position.x = 135 * this.scaleFactorX;
                        } else {
                            cardSprite.position.x = 170 * this.scaleFactorX;
                        }
                        cardSprite.position.y = -58 * this.scaleFactorY;
                        cardSprite.zIndex = 0;
                        this.players[i].frame.container.addChild(cardSprite);
                    });

                    this.mainContainer.addChild(this.players[i].frame.container);
                }


                this.mainContainer.addChild(this.tableBackground);
                /* text.alpha = 0.4;
                 text.position.x = this.app.renderer.width / 2;
                 text.position.y = this.app.renderer.height / 2;
                 this.app.stage.addChild(text); */
                this.$nextTick(() => {
                    window.addEventListener('resize', this.resize);
                });
                this.resize();
            },
            resize() {

                this.orientation = window.matchMedia("(orientation: portrait)").matches ? 'portrait' : 'landscape';
                if (this.orientation === 'portrait') {
                    let width = window.innerHeight > 1080 ? 1080 : window.innerHeight;
                    let height = window.outerWidth > 1920 ? 1920 : window.outerWidth;

                    this.mainContainer.position.set(height, 0);
                    this.app.renderer.resize(width, height);
                    this.setBackgroundSize(width, height);
                    this.setScaleFactor(width, height, true);
                    this.resetScales();
                } else {
                    let width = window.outerWidth > 1920 ? 1920 : window.outerWidth;
                    let height = window.outerHeight > 1080 ? 1080 : window.outerHeight;
                    this.mainContainer.transform.rotation = 0;
                    this.mainContainer.transform.position.x = 0;
                    this.mainContainer.transform.position.y = 0;
                    this.app.renderer.resize(width, height);
                    this.setBackgroundSize(width, height);
                    this.setScaleFactor(width, height, true);
                    this.resetScales();
                }
            },
            resetScales() {
                Object.keys(this.players).forEach((playerNumber) => {
                    let player = this.players[playerNumber];
                    player.cards.forEach((cardSprite, index) => {
                        cardSprite.width = 76.89 * this.scaleFactorX;
                        cardSprite.height = 108.24000000000001 * this.scaleFactorY;
                        if (index === 0) {
                            cardSprite.position.x = 135 * this.scaleFactorX;
                        } else {
                            cardSprite.position.x = 170 * this.scaleFactorX;
                        }
                        cardSprite.position.y = -58 * this.scaleFactorY;
                        cardSprite.zIndex = 0;
                    });
                    player.frame.sprite.width = 292 * this.scaleFactorX;
                    player.frame.sprite.height = 136 * this.scaleFactorY;
                    player.frame.container.position.x = player.frame.x * this.scaleFactorX;
                    player.frame.container.position.y = player.frame.y * this.scaleFactorY;
                });

            },
            setBackgroundSize(width, height) {
                this.tableBackground.width = width;
                this.tableBackground.height = height;
            },
            setScaleFactor(width, height) {
                let diff = width - 1920;
                if (diff >= 0) {
                    this.scaleFactorX = 1.0;
                } else {
                    diff = Math.abs(diff);
                    this.scaleFactorX = ((Math.ceil((width / 1920) * 100) * 0.01).toFixed(2)) * 1;
                }

                diff = height - 1080;
                console.log(height, diff);
                if (diff >= 0) {
                    this.scaleFactorY = 1.0;
                } else {
                    diff = Math.abs(diff);
                    this.scaleFactorY = ((Math.ceil((height / 1080) * 100) * 0.01).toFixed(2)) * 1;
                }

                console.log(this.scaleFactorY);
            }
        }
    };
</script>
